import { useJobDecisions } from "../reducers/decisionSlice";
import PropTypes from 'prop-types';
import DecisionTable from "./DecisionTable";

/**
 * Display decisions referncing the specified job and allow the decision details to be viewed.
 * @component
 */
const JobDecisions = ({ jobid, style }) => {
    const decisions = useJobDecisions(jobid);

    return <DecisionTable decisions={decisions} style={style}></DecisionTable>;
}

JobDecisions.propTypes = {
    /**
     * The job ID whose decisions should be displayed
     */
    jobid: PropTypes.string
}

export default JobDecisions;